import { useState } from "react";
import Button from "./Button";
import Icon from "./icons/Icon";
import Sheet from "./Sheet";

/**
 * Menue als Sheet. eintraege: [{ icon, label, onClick, zusatz, gefahr,
 * frage }] — mit "frage" fragt der Eintrag erst nach (z. B. Spiel beenden),
 * statt sofort auszuloesen.
 * @category bausteine
 */
export function SpielMenue({ titel = "Menü", eintraege, onClose, sofortFragen = false }) {
  // sofortFragen: direkt mit der Rueckfrage des ersten Eintrags oeffnen
  // (z. B. Knopf "Raum verlassen" — dort waere ein Menue ein Umweg).
  const [rueckfrage, setRueckfrage] = useState(() =>
    sofortFragen ? eintraege.filter(Boolean).find((e) => e.frage) || null : null
  );

  if (rueckfrage) {
    return (
      <Sheet titel={rueckfrage.label} onClose={onClose}>
        <p className="menue-frage">{rueckfrage.frage}</p>
        <Button variant="neben" className="falsch" onClick={rueckfrage.onClick}>
          <Icon name={rueckfrage.icon} />
          {rueckfrage.bestaetigen || "Ja"}
        </Button>
        <Button variant="text" onClick={() => (sofortFragen ? onClose() : setRueckfrage(null))}>
          Abbrechen
        </Button>
      </Sheet>
    );
  }

  return (
    <Sheet titel={titel} onClose={onClose}>
      {eintraege.filter(Boolean).map((e) => (
        <button
          key={e.label}
          type="button"
          className={`menue-zeile${e.gefahr ? " gefahr" : ""}`}
          onClick={() => (e.frage ? setRueckfrage(e) : e.onClick())}
        >
          <Icon name={e.icon} />
          {e.label}
          {e.zusatz && <small>{e.zusatz}</small>}
        </button>
      ))}
      <Button variant="text" onClick={onClose}>
        Schließen
      </Button>
    </Sheet>
  );
}

export default SpielMenue;
